import React from "react";

import UserSearchFilter from "../../../../../../components/Administration/Jobs/UserJobs/UserSearchFilter";
import UserDashboardHeader from "../../../../../../components/Administration/Jobs/UserJobs/UserDashboardHeader";
import DeleteModal from "../../../../../../components/modelpopup/deletePopup";
import Breadcrumbs from "../../../../../../components/Breadcrumbs";
import UserOfferedJobsTable from "./UserOfferedJobsTable";
import { useTranslation } from "react-i18next";

const UserOfferedJobs = () => {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t('Offered Jobs')}
          title="Dashboard"
          subtitle={t('Jobs')+' / '+t('User Dashboard')+' / '+t('Offered Jobs')}
        />
        <UserDashboardHeader />
        <UserSearchFilter />
        <UserOfferedJobsTable />
        <DeleteModal Name={t('Delete')} />
      </div>
    </div>
  );
};

export default UserOfferedJobs;
